/**
 * Created by m.igrachev on 7/28/2017.
 */
export default function(array, toExclude) {
    if (!array) return array;
    if (array.constructor !== Array) return array;

    let result = array;
    if (toExclude.constructor === Array) {
        for (let toExcludeElement of toExclude) {
            result = exclude(result, toExcludeElement);
        }
    } else {
        result = exclude(result, toExclude);
    }

    return result;
}

function exclude(array, toExclude) {
    let resultArray = Array.from(array);
    let toExcludeIndex = resultArray.indexOf(toExclude);
    if (toExcludeIndex >= 0) {
        //Note: Destructive operation! That is why we define resultArray.
        resultArray.splice(toExcludeIndex, 1);
    }
    return resultArray;
}
